import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('./components/MainLayout'),
            children: [
                {
                    path: "",
                    name: "index",
                    component: () => import('./components/main/Landing')
                },
                {
                    path: "changelog",
                    name: "changelog",
                    component: () => import('./components/main/ChangeLog')
                },
                {
                    path: "sales",
                    name: "sales",
                    component: () => import('./components/main/Sales')
                },
                {
                    path: "contact",
                    name: "contact",
                    component: () => import('./components/main/Contact')
                },
                {
                    path: "terms",
                    name: "terms",
                    component: () => import('./components/main/Terms')
                },
                {
                    path: "privacy",
                    name: "privacy",
                    component: () => import('./components/main/Privacy')
                },
                {
                    path: "about",
                    name: "about",
                    component: () => import('./components/main/About')
                },
                {
                    path: "products/",
                    component: () => import('./components/main/products/ProductsLayout'),
                    children: [
                        {
                            path: "marketplace",
                            name: "marketplace",
                            component: () => import('./components/main/products/Marketplace')
                        },
                        {
                            path: "express",
                            name: "express",
                            component: () => import('./components/main/products/Express')
                        },
                    ]
                },
                {
                    path: "media",
                    component: () => import('./components/main/media/MediaLayout'),
                    children: [
                        {
                            path: "media",
                            name: "media",
                            component: () => import('./components/main/media/MediaHome')
                        },
                        {
                            path: "lisbon-web-summit",
                            name: "lisbon-web-summit",
                            component: () => import('./components/main/media/LisbonWebSummit')
                        }
                    ]
                },
		//{ path: '*', redirect: { name: "index" }}
            ]
        }
    ]
})
